import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { PpmPredictionData } from "./api/types";
import { PpmItem } from "./models/PpmModel";
import { SensorDataItem } from "./models/SensorDataModel";
import { SensorItem } from "./models/SensorModel";
import { Command, StationItem } from "./models/StationModel";
import { TrapStationWithDetail } from "./models/TrapModel";

export default class PpmVuexModule extends AbacoVuexModule {
    @State() ppmItem!: PpmItem | null;
    @State() ppmNavBarFilterOpen!: boolean;
    @State() currentStation!: StationItem;
    @State({ default: [] }) stations!: StationItem[];
    @State({ default: [] }) sensorData!: SensorDataItem[];
    @State({ default: "tuta-absoluta" }) selectedDisease!: string;
    @State({ default: 0 }) triggerStationSelection!: number;
    @State({ default: 0 }) triggerStationsLoaded!: number;
    @State({ default: 0 }) triggerZoomOverStation!: number;
    @State({ default: 0 }) triggerZoomOverSensorData!: number;
    @State() currentSensorData!: SensorDataItem;
    @State() currentSensor!: SensorItem;
    @State() stationCommands!: Command[];
    @State({ default: [] }) sensors!: SensorItem[];
    @State({ default: false }) loadingSensorHistoryData!: boolean;
    @State({ default: false }) loadingStations!: boolean;
    @State({ default: [] }) currentPosition!: number[];
    @State({ default: [] }) pestsPredictionList!: PpmPredictionData[] | null;

    @State({ default: null }) curStationId!: string | null;
    @State({ default: null }) curPestCode!: string | null;
    @State({ default: null }) curMonthId!: number | null;
    @State({ default: "yearly" }) curPeriodTypeId!: "monthly" | "yearly";

    @State({ default: null }) curTrapStation!: TrapStationWithDetail | null;
}
